import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { useSelector } from "react-redux";
import DrawerComponent from "../../common/DrawerComponent";
import ReferralWidget from "../../ReferalPage/ReferralWidget";
import { useScreenWidth } from "../../SubscriptionPageV2/hooks";
const ReferralWidgetDrawer = ({ toggleDrawer, openDrawer }) => {
    const isMobile = useScreenWidth() < 900;
    const referralData = useSelector((state) => state.referalInfo.referalInfo);
    return (_jsx(DrawerComponent, { crossButton: true, open: openDrawer, toggleDrawer: toggleDrawer, anchor: isMobile ? "bottom" : "right", children: _jsx(ReferralWidget, { referralData: referralData }) }));
};
export default ReferralWidgetDrawer;
